export function buttonTextTheme(colors) {
    //language=SCSS
    return `& {
        color: ${colors.text};
        
        &:not(.no-hover):not([disabled]) {
            &:hover, &.test-hover {
                color: ${colors.textHover || colors.text};
            }
            &:focus, &.test-focus {
                outline: unset;
                box-shadow: unset;
                color: ${colors.textFocus};
            }
            &:hover:active, &:active, &.test-active, &:not(:disabled):not(.disabled):active {
                color: ${colors.textHover};
                outline: unset;
                border-color: ${colors.border};
            }
        }
        
        &.no-hover {
            &:hover:active, &:active, &.test-active, &:not(:disabled):not(.disabled):active {
                color: ${colors.text};
                border-color: ${colors.border};
            }
        }
    }`;
}
